/**
 * Schema Compare Feature Module
 *
 * Registers the schema-compare workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the schema-compare workspace component
registerWorkspaceComponent(
  'schema-compare',
  lazyWorkspaceTab(() => import('./components/SchemaCompareTab').then((m) => ({ default: m.SchemaCompareTab }))),
);

// Re-export components
export { SchemaCompareSetupDialog } from './components/SchemaCompareSetupDialog';
